import { Outlet } from 'react-router-dom'
import VoiceHeader from './VoiceHeader'

export default function AppLayout() {
  return (
    <div className="min-h-screen w-full min-w-0 flex flex-col bg-background text-foreground">
      <VoiceHeader />
      <main className="flex-1 w-full min-w-0 px-4 py-6 sm:px-6">
        <Outlet />
      </main>
    </div>
  )
}
